import { useEffect, useState } from "react";
import { useLocale } from "../i18n/LocaleContext";
import { localePath } from "../i18n/config";
import {
  getSavedLocale,
  preferredSupportedLocale,
  saveLocale,
} from "../i18n/detect";
import { BANNER_TEXT } from "../i18n/banner";

// On the English home page only: offer the device's language once. Fixed
// position, so showing it after mount doesn't move the page.
export function LanguageBanner() {
  const { locale, route } = useLocale();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (route === "home" && locale === "en" && !getSavedLocale()) {
      setTarget(preferredSupportedLocale(navigator.languages));
    }
  }, [route, locale]);

  if (!target) {
    return null;
  }

  const text = BANNER_TEXT[target];

  function dismiss() {
    saveLocale("en");
    setTarget(null);
  }

  return (
    <div
      lang={target}
      className="fixed inset-x-0 top-4 z-50 mx-auto flex w-[calc(100%_-_2rem)] max-w-md flex-wrap items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-800 shadow-lg"
    >
      <span>{text.text}</span>
      <div className="flex items-center gap-2">
        <button
          onClick={dismiss}
          className="rounded-lg px-3 py-1.5 text-gray-500 hover:bg-gray-100"
        >
          {text.dismiss}
        </button>
        <a
          href={localePath(target, "/")}
          hrefLang={target}
          onClick={() => saveLocale(target)}
          className="rounded-lg bg-red-600 px-3 py-1.5 font-semibold text-white hover:bg-red-700"
        >
          {text.accept}
        </a>
      </div>
    </div>
  );
}
